import { Component } from 'shimmer'

import { Vector3, CatmullRomCurve3, Line, LineBasicMaterial, BufferGeometry } from 'three'
import { randomRange } from '@/utils/Maths'

import { Loader } from '@/utils/Loader'

const axis = new Vector3()
const up = new Vector3(0, 0, 1)
const nbrStep = randomRange(1700, 2200)

export class Train extends Component {
  constructor (arrayPositions, url, invert = false) {
    super({name: 'Train'})

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.url = url
    this.invert = invert

    let positions = arrayPositions.map(pos => { return new Vector3(pos[0], pos[2], -pos[1]) })
    if (this.invert) {
      positions = positions.reverse()
    }
    this.curve = new CatmullRomCurve3(positions, true)

    this.promises.push(Loader.load(this.url).then(train => {
      this.train = train
      this.add(this.train)
    }))

    // const curveHelper = new Line(new BufferGeometry().setFromPoints(this.curve.getPoints(500)), new LineBasicMaterial({color: 0xff0000}))
    // this.add(curveHelper)

    this.step = Math.floor(Math.random()*nbrStep)

    Promise.all(this.promises).then(this.resolve)
  }

  onUpdate () {
    if (!this.train) { return }
    this.step = (this.step + 1)%nbrStep

    const itemPos = this.curve.getPoint(this.step / nbrStep)
    const tangent = this.curve.getTangent(this.step / nbrStep).normalize()
    axis.crossVectors( up, tangent ).normalize()
    const radians = Math.acos(up.dot(tangent))

    this.train.position.copy(itemPos)
    this.train.quaternion.setFromAxisAngle( axis, radians )
  }
}